import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { color } from '../../../styles/helpers/variables';
import { fontFamilyBody } from '../../../styles/helpers/mixins';

const ProductPageUSP = ({ deliveryInformation }) => (
  <List>
    <ListItem>Frakt från 99 – 790 kr</ListItem>
    {deliveryInformation && <ListItem>Leveranstid: {deliveryInformation}</ListItem>}
    <ListItem>14 Dagar returrätt</ListItem>
    <ListItem>3 Års reklamationsrätt</ListItem>
  </List>
);

ProductPageUSP.defaultProps = {
  deliveryInformation: null
};

ProductPageUSP.propTypes = {
  deliveryInformation: PropTypes.string
};

export default ProductPageUSP;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 -10px -5px 0;
  padding: 0;
  ${fontFamilyBody}
  font-size: 14px;
  font-weight: normal;
  line-height: 1.375;
  color: ${color.black};
`;
const ListItem = styled.li`
  flex: 0 0 100%;
  position: relative;
  max-width: 100%;
  padding: 0 10px 5px 18.5px;
  @media screen and (min-width: 1250px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  &:before {
    content: '';
    position: absolute;
    top: 7px;
    left: 1px;
    height: 4px;
    width: 8px;
    border-left: 1px solid ${color.primary};
    border-bottom: 1px solid ${color.primary};
    transform: rotate(-45deg);
  }
`;



// WEBPACK FOOTER //
// ./src/components/productPage/ProductUSP/ProductUSP.js